import Alarm from "./Alarm";

export default class AlarmBattery extends Alarm {
	constructor(data) {
		super(data);
		this.level_battery = data.level_battery || 0;
	}
}
